import React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { MSkeleton } from '@Components/Base';
import { ContactListProps } from '../types';
import ContactCard from './components/ContactCard';
import ContactNoData from '../components/ContactNoData';
import styles from './contact-list-mobile.module.css';

const ContactListMobile: React.FC<ContactListProps> = ({
  dataSource,
  isLoading = false,
  onView,
  onEdit,
  isSearchApplied = false,
  isFiltersApplied = false,
}) => {
  if (isLoading) {
    return <MSkeleton paragraph={{ rows: 3 }} active />;
  }

  if (!dataSource || !dataSource.length) {
    return (
      <ContactNoData
        isSearchApplied={isSearchApplied}
        isFiltersApplied={isFiltersApplied}
      />
    );
  }

  return (
    <div className={styles.contactListMobile}>
      <InfiniteScroll
        next={() => {
          // For now, we'll use pagination instead of infinite scroll
          // This can be enhanced later if needed
        }}
        hasMore={false} // Disable infinite scroll for now
        loader={<MSkeleton paragraph={{ rows: 1 }} active />}
        dataLength={dataSource.length}
        scrollableTarget="scrollableList"
      >
        {dataSource.map((contact) => (
          <ContactCard
            key={contact.empNumber}
            contact={contact}
            onView={onView}
            onEdit={onEdit}
          />
        ))}
      </InfiniteScroll>
    </div>
  );
};

export default ContactListMobile;
